import { render } from "./DeleteTicket.vue?vue&type=template&id=35212d09"
import script from "./DeleteTicket.vue?vue&type=script&lang=js"
export * from "./DeleteTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__